<template>
  <b-modal
    id="fields-settings-modal"
    :ok-title="$t('generals.close')"
    modal-class
    ok-only="modal-primary"
    centered
    title="Настройка полей"
  >
    <b-form-group>
      <b-form-checkbox
        v-for="option in fields"
        :key="option.key"
        v-model="option.visible"
        name="fields"
      >
        {{ $t(option.label) }}
      </b-form-checkbox>
    </b-form-group>
  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BFormCheckboxGroup,
  BFormCheckbox,
  BFormGroup,
} from 'bootstrap-vue'
export default {
  components: {
    BModal,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormGroup,
  },
  props: ['fields'],
}
</script>
